import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-ndc-registration-manual-card',
  templateUrl: './ndc-registration-manual-card.component.html',
  styleUrls: ['./ndc-registration-manual-card.component.scss']
})
export class NdcRegistrationManualCardComponent implements OnInit {
  @Input() cardSectionsMap: Map<string, any[]> = new Map();
  imageToPopUp: string = '';
  constructor() {}

  ngOnInit(): void {}
  orderByAdditionalOrderField = (a: KeyValue<any, any>, b: KeyValue<any, any>): number => {
    return a.value[0][0].sectionOrder - b.value[0][0].sectionOrder;
  };

  setPopUpImage(event: any, card: any) {
    this.imageToPopUp = card.headImage;
  }

  getPopUpImage() {
    return this.imageToPopUp;
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }
    return documentToHtmlString(richText);
  }
}
